import styled from 'styled-components/native'
import DialogueCard from 'APP/Converse/Card'

export const Card = styled(DialogueCard)`
  padding: ${({ theme }) => theme.metrics.baseMargin * 1.5}px
    ${({ theme }) => theme.metrics.baseMargin}px;
  background-color: ${({ theme }) => theme.colors.clientCardBg};
  box-shadow: none;
  shadow-color: transparent;
  shadow-offset: 0px 0px;
  shadow-opacity: 0px;
  shadow-radius: 0px;
  elevation: 0;
`

export const Header = styled.View`
  flex-direction: column;
  gap: ${({ theme }) => theme.metrics.baseMargin / 5}px;
`

export const ScaleContainer = styled.View`
  margin-top: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`
